import { render, staticRenderFns } from "./WriterCell.vue?vue&type=template&id=65cb59c2"
import script from "./WriterCell.vue?vue&type=script&lang=js"
export * from "./WriterCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports